/**
 * Permission utility functions for role-based access control
 */

export interface UserProfile {
  role: 'admin' | 'inspector' | 'client'
  supervisor?: boolean | null
}

/**
 * Check if user has full admin access
 * Returns true for:
 * - Users with role 'admin'
 * - Inspectors with supervisor = true
 */
export function hasAdminAccess(profile: UserProfile | null): boolean {
  if (!profile) return false
  return profile.role === 'admin' || profile.supervisor === true
}

/**
 * Check if user is an admin (by role)
 */
export function isAdmin(profile: UserProfile | null): boolean {
  if (!profile) return false
  return profile.role === 'admin'
}

/**
 * Check if user is a supervisor (inspector with supervisor flag)
 */
export function isSupervisor(profile: UserProfile | null): boolean {
  if (!profile) return false
  return profile.role === 'inspector' && profile.supervisor === true
}

/**
 * Check if user is an inspector (including supervisors)
 */
export function isInspector(profile: UserProfile | null): boolean {
  if (!profile) return false
  return profile.role === 'inspector'
}

